import * as Sentry from '@sentry/react';
import { matchPath } from 'react-router-dom';
import _get from 'lodash/get';

import identifyUser from 'utils/analytics/identifyUser';
import {
  isChunkLoadError,
  hasAttemptedChunkReloadThisSession,
} from 'utils/extra/chunkReload';

export default function loggingAndAnalyticsSetup(history) {
  const sentryApp = process.env.REACT_APP_SENTRY_APP_ID;
  const environment = process.env.REACT_APP_MODE;

  if (sentryApp) {
    Sentry.init({
      dsn: sentryApp,
      environment,
      // Must match the RELEASE built in scripts/upload_sentry_sourcemaps.sh,
      // which reads the same sha from REACT_APP_CURRENT_GIT_SHA.
      release: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_CURRENT_GIT_SHA}`,
      integrations: [
        Sentry.reactRouterV5BrowserTracingIntegration({
          history,
          matchPath,
        }),
      ],

      tracesSampleRate: 0.1, // Start low to control costs

      // Classifies chunk-load errors instead of letting them count as
      // ordinary crashes. See src/utils/extra/chunkReload.js and
      // docs/NETLIFY_MIGRATION.md, §9. Catches every chunk error
      // Sentry sees - including ones captured by its own default integrations,
      // not only the ones routed through logError - because it matches on the
      // event itself rather than a tag set at the call site.
      beforeSend(event, hint) {
        const originalError = _get(hint, 'originalException');
        const message = _get(event, 'exception.values[0].value');

        if (!isChunkLoadError(originalError) && !isChunkLoadError(message)) {
          return event;
        }

        // A reload is already recovering this session; this event is noise -
        // it will not repeat once the user is on the new build.
        if (hasAttemptedChunkReloadThisSession()) {
          return null;
        }

        event.level = 'warning';
        event.fingerprint = ['chunk-load-error'];
        event.tags = { ...(event.tags || {}), chunk_error: true };
        return event;
      },
    });
  }

  identifyUser();
}
